<template>
  <g>
    <polygon
      :points="topPolygon"
      fill="#6d6d6d"
    />
    <polygon
      :points="rightPolygon"
      fill="#6d6d6d"
    />
    <polygon
      :points="frontPolygon"
      fill="#b0b0b0"
    />
  </g>
</template>

<script>
  export default {
    name: 'Thruster',
    props: {
      x: Number,
      y: Number,
      rackWidth: Number,
      left: Boolean,
      right: Boolean,
      front: Boolean,
      back: Boolean,
      height: {
        type: Number,
        default: 2.5,
      },
    },
    computed: {
      xOffset() {
        return this.rackWidth / 1.8;
      },
      yOffset() {
        return this.rackWidth / 3;
      },
      points() {
        return {
          lf: [`${this.x}`, `${this.y}`],
          rf: [`${this.x + this.rackWidth}`, `${this.y}`],
          rb: [`${this.x + this.rackWidth + this.xOffset}`, `${this.y - this.yOffset}`],
          lb: [`${this.x + this.xOffset}`, `${this.y - this.yOffset}`],
        };
      },
      topPolygon() {
        const p = this.points;

        if (this.back && this.left) {
          return [p.lf, p.rb, p.lb].join(' ');
        }

        if (this.back && !this.left) {
          return [p.rf, p.rb, p.lb].join(' ');
        }

        if (this.front && this.right) {
          return [p.lf, p.rf, p.rb].join(' ');
        }

        if (this.front && !this.right) {
          return [p.lf, p.rf, p.lb].join(' ');
        }

        return '';
      },
      rightPolygon() {
        const p = this.points;

        if (this.right || (this.back && !this.left)) {
          return [
            p.rf,
            p.rb,
            [p.rb[0], +p.rb[1] + this.height],
            [p.rf[0], +p.rf[1] + this.height],
          ].join(' ');
        }

        return '';
      },
      frontPolygon() {
        const p = this.points;

        if (this.back && this.left) {
          return [
            p.lf,
            p.rb,
            [p.rb[0], +p.rb[1] + this.height],
            [p.lf[0], +p.lf[1] + this.height],
          ].join(' ');
        }

        if (this.back && !this.left) {
          return [
            p.lb,
            p.rf,
            [p.rf[0], +p.rf[1] + this.height],
            [p.lb[0], +p.lb[1] + this.height],
          ].join(' ');
        }

        return [
          p.lf,
          p.rf,
          [p.rf[0], +p.rf[1] + this.height],
          [p.lf[0], +p.lf[1] + this.height],
        ].join(' ');
      },
    },
  };
</script>
